import React from 'react';

const Hero: React.FC = () => {
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/a878ab7d56e8039f0516d3d6f4bb901b.jpg')`
      }}
    >
      <div className="container mx-auto px-6 text-center text-white">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
            ManageEngine Products
          </h1>
          <p className="text-xl md:text-2xl mb-8 leading-relaxed">
            Comprehensive IT management and security solutions for modern enterprises. 
            Discover our 120+ award-winning products and free tools to manage and secure your IT infrastructure.
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12 text-left">
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <i className="ri-check-line text-2xl text-green-400"></i>
                <span className="text-lg">280,000+ customers worldwide</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-check-line text-2xl text-green-400"></i>
                <span className="text-lg">Recognized by top analyst firms</span>
              </div>
            </div>
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <i className="ri-check-line text-2xl text-green-400"></i>
                <span className="text-lg">Free trials with premium features</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-check-line text-2xl text-green-400"></i>
                <span className="text-lg">On-premises, public & private cloud</span>
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
              Free Downloads
            </button>
            <button className="bg-transparent border-2 border-white hover:bg-white hover:text-gray-900 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
              View All Products
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;